import config from "config/config";
import type { LanguageCode } from "config/languages";
import languages from "config/languages";

const getDomainFromLanguage = (language: LanguageCode) => languages.get(language)?.localDomain || config.websiteUrl;

export default getDomainFromLanguage;
